<template>
  <div>
    <div class="row">
      <div class="col-sm-6">
        <b-form @submit.stop.prevent="handleSubmit">
          <fieldset>
            <b-form-radio-group class="customize-notifications" v-model="customNotifications"
                          :options="options"
                          stacked
                          name="radioInline">
            </b-form-radio-group>
            <table v-if="!customNotifications" class="table">
              <thead>
                <tr>
                  <th>Notify me when...</th>
                  <th>Email</th>
                  <th>Slack</th>
                  <th>Browser</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="row in userSettings" :key="row.id">
                  <td>{{row.event_description}}</td>
                  <td><b-form-checkbox
                        v-model="row.email"></b-form-checkbox>
                  </td>
                  <td><b-form-checkbox
                        v-model="row.slack" :disabled="nonEditableEvents.includes(row.event)"></b-form-checkbox>
                  </td>
                  <td><b-form-checkbox
                        v-model="row.browser" :disabled="nonEditableEvents.includes(row.event)"></b-form-checkbox>
                  </td>
                </tr>
              </tbody>
            </table>
          </fieldset>
          <div role="tablist" v-show="customNotifications">
            <b-card v-for="mbSettings in mailboxesSettings" :key="mbSettings.mailbox_id" no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-btn block href="#" v-b-toggle.mailboxes-settings variant="default">{{mbSettings.mailbox_name}}</b-btn>
              </b-card-header>
              <b-collapse id="mailboxes-settings" accordion="mailboxes-accordion" role="tabpanel">
                <b-card-body>
                   <table class="table">
                    <thead>
                      <tr>
                        <th>Notify me when...</th>
                        <th>Email</th>
                        <th>Slack</th>
                        <th>Browser</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="row in mbSettings.notification_settings" :key="row.id">
                        <td>{{row.event_description}}</td>
                        <td><b-form-checkbox
                              v-model="row.email"></b-form-checkbox>
                        </td>
                        <td><b-form-checkbox
                              v-model="row.slack"></b-form-checkbox>
                        </td>
                        <td><b-form-checkbox
                              v-model="row.browser"></b-form-checkbox>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </b-card-body>
              </b-collapse>
            </b-card>
          </div>
          <b-button type="submit">Save</b-button>
        </b-form>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'NotificationSettings',
  data () {
    return {
      nonEditableEvents: ['message_assigned', 'customer_replies_to_assigned_message', 'user_replies_to_assigned_message', 'mentioned_at'],
      userSettings: [],
      mailboxesSettings: [],
      customForMailbox: Boolean,
      customNotifications: Boolean,
      options: [
        { text: 'Use the same notification settings for all mailboxes', value: false },
        { text: 'Customize notification settings for each mailbox', value: true }
      ]
    }
  },

  computed: {
    ...mapGetters(['currentUser'])
  },

  mounted () {
    this.customNotifications = this.currentUser.customNotifications
    this.getSettings()
  },

  methods: {
    getSettings () {
      var vm = this
      this.$http
        .get('/notification_settings')
        .then(function (response) {
          vm.userSettings = response.data.user_settings
          vm.mailboxesSettings = response.data.mailboxes_settings
        })
        .catch(e => { console.log(e) })
    },

    handleSubmit () {
      var vm = this
      this.$http.post('/notification_settings/', { user_settings: vm.userSettings, mailboxes_settings: vm.mailboxesSettings, custom_notifications: vm.customNotifications })
        .then(response => this.submitSuccessful(response))
        .catch(e => { console.log(e) })
    },

    submitSuccessful () {
      this.$store.dispatch('loadUser')
      this.$router.push('/boards')
    }
  }
}
</script>
<style scoped>
.customize-notifications {
  text-align: left
}
</style>



// WEBPACK FOOTER //
// src/components/NotificationSettings.vue